import React, { useContext, useState } from 'react';
import SEO from './common/SEO';
import HeaderComponent from '../../components/Header/HeaderComponent';
import FooterComponent from '../../components/Footer/FooterComponent';
import '../../styles/style.scss';
import DonationPopup from '../../components/popop/donotion-popup';
import { UseSessionPopup } from '../../hooks/use-first-visit';
import { AppContext } from '../../apollo/wrap-root-element';
// import DonationToast from '../../components/popop/donationToast';

export default function DefaultLayoutComponent({
  children,
  seo = {},
  description,
  title,
  openGraphImage,
  timeline,
  isForTimelineGraph,
  gcbooks,
  backUrl,
  gcbooksList,
  hideDonationPopup = false,
  simplifiedHeader = false,
  hideBackArrow = false,
}) {
  const { showPopup, closePopup, setShowPopup } = useContext(AppContext);
  const [donationAmount, setDonationAmount] = useState(0);

  const handleDonationComplete = (amount) => {
    setDonationAmount(amount);
  };
  return (
    <>
      <SEO
        seoData={seo}
        title={title}
        description={description}
        header={{
          siteTitle: 'Lineage Journey',
        }}
        openGraphImage={openGraphImage}
      />
      <HeaderComponent
        backUrl={backUrl}
        gcbooks={gcbooks}
        isForTimelineGraph={isForTimelineGraph}
        timeline={timeline}
        simplifiedHeader={simplifiedHeader}
        hideBackArrow={hideBackArrow}
      />
      {!hideDonationPopup && (
        <DonationPopup isOpen={showPopup} onClose={closePopup} onDonationComplete={handleDonationComplete} />
      )}
      {/* {!hideDonationPopup && <DonationToast />} */}

      {children}
      {!timeline || gcbooksList ? <FooterComponent /> : ''}
    </>
  );
}
